import { render, staticRenderFns } from "./PopupGeolocation.vue?vue&type=template&id=08c0dc5e"
import script from "./PopupGeolocation.vue?vue&type=script&lang=js"
export * from "./PopupGeolocation.vue?vue&type=script&lang=js"
import style0 from "./PopupGeolocation.vue?vue&type=style&index=0&id=08c0dc5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports